import styled from '@emotion/styled';

export const Card = styled.div`
	background-color: ${({ formBackgroundColor }) => (formBackgroundColor ? `${formBackgroundColor}` : 'white')};
	border-radius: 10px;
	box-shadow: var(--container-box-shadow);
	width: 100%;
	margin-bottom: 2rem;
`;
export const TrackingContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;

	width: 100%;
	height: 20rem;

	> .lottie-1 {
		position: absolute;
		top: 0;
	}

	> .lottie-2 {
		position: absolute;
		top: 10%;
	}

	> .lottie-3 {
		position: absolute;
		top: 5%;
	}

	> .lottie-4 {
		position: absolute;
		top: 8%;
	}
`;

export const IconColumn = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	> span.typography {
		text-align: center;
		height: 4rem;
	}
`;

export const ContentRow = styled.div`
	position: relative;
	border-radius: var(--small-border-radius);
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 100%;
`;
export const Progressbar = styled.div`
	> div {
		position: absolute;
		top: 65%;
		left: 12%;
		width: 75%;
		z-index: 1;
	}
`;
export const IconContainer = styled.div`
	padding: 1rem;
	z-index: 9;
	> div.icon {
		background-color: ${({ formBackgroundColor }) => (formBackgroundColor ? `${formBackgroundColor}` : `white`)};
		border-radius: 50%;
	}
`;

export const LottieContainer = styled.div`
	border: none;
	background: transparent;
	filter: grayscale(100%);
	transition: all 0.3s;

	&.active {
		filter: none;
	}
`;

export const TrackingContent = styled.div`
	padding: var(--padding-4);
	> div.row {
		body[dir='rtl'] & {
			text-align: right;
		}
	}
`;
export const StatusContainer = styled.div`
	padding: 10px;
	text-align: center;
	border-radius: calc(0.35rem - 1px) calc(0.35rem - 1px) 0 0;
	background: ${({ headerBackgroundColor }) => (headerBackgroundColor ? `${headerBackgroundColor}` : '#2ecc71')};
	border-radius: 5px;
	> span.typography {
	}
`;
